var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kkg-notification"},[_c('div',{staticClass:"kkg-close clickable",on:{"click":function($event){return _vm.$emit('close', false)}}},[_c('v-icon',[_vm._v("$vuetify.icons.Close")])],1),_vm._v(" "),_c('kk-dynamic-html',{attrs:{"html":_vm.notificationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }